import {CommentIcon} from '@primer/octicons-react'
import {ZeroState} from '../toolbar/ZeroState'

export interface CommentsZeroStateProps {
  hasItems: boolean
}

/**
 * Zero state component for comments panels.
 * Shows different messages based on whether items exist but are filtered out,
 * or no items exist at all.
 */
export function CommentsZeroState({hasItems}: CommentsZeroStateProps) {
  const heading = hasItems ? 'No comments match the current filter' : 'No comments yet'
  return (
    <div className="d-flex flex-column position-relative width-full height-full flex-justify-center">
      <ZeroState
        description="Comments will show up here as soon as there are some."
        heading={heading}
        icon={CommentIcon}
        headingLevel="h2"
      />
    </div>
  )
}
